module.exports = __webpack_public_path__ + "img/logo-bpr-1-01.7d301a93.png";